export default __webpack_public_path__ + "images/UH.27b6cba.png";